import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ProductPackage from '../reusable/ProductPackage';

/**
 * CordellConnectProductPackage.
 * Page for product.
 *
 * @author  Manny
 * @param   {Object}      props.coupon          Coupon object.
 * @param   {Object}      props.method          Optional industry params.
 * @param   {Function}    props.onSelectPackage Handles onClick for selecting a package.
 * @param   {Number}      props.productId       Id number of the product.
 * @param   {Object}      props.productsConfig  Product configurations.
 * @returns {JSX.Element} The component markup.
 */

const CordellConnectProductPackage = ({
  coupon,
  method,
  onSelectPackage,
  productId,
  productsConfig
}) => {
  const [activeKey, setActiveKey] = useState('2');
  const [packageKey, setPackageKey] = useState(
    productsConfig
      ? Object.keys(productsConfig.packages)[Object.keys(productsConfig.packages).length - 1]
      : ''
  );

  // remove disabled packages
  if (productsConfig) {
    for (const [singlePackageKey, value] of Object.entries(productsConfig.packages)) {
      if(!value.enabled) {
        delete productsConfig.packages[singlePackageKey];
      }
    }
  }

  const productPackage = {
    contactText: 'Contact Us',
    contactUrl: 'https://www.cotality.com/au/products/cordell-connect#rc-form',
    packageHeader: 'Cordell Connect - AU Project Information',
    packageTitle: 'Customise Cordell Connect',
    packageTexts: [
      'For more tailored pricing to suit national access, large',
      'commercial, civil or mining sectors please call us.'
    ],
    productId: productId,
    productName: 'cordell'
  };

  return (
    <ProductPackage
      activeKey={activeKey}
      coupon={coupon}
      onSelectPackage={onSelectPackage}
      method={method}
      packageKey={packageKey}
      productPackage={productPackage}
      productsConfig={productsConfig}
      setActiveKey={setActiveKey}
      setPackageKey={setPackageKey}
    />
  );
};

CordellConnectProductPackage.propTypes = {
  coupon: PropTypes.object,
  method: PropTypes.object,
  onSelectPackage: PropTypes.func.isRequired,
  productId: PropTypes.number,
  productsConfig: PropTypes.object
};

export default CordellConnectProductPackage;
